export default "__VITE_ASSET__Bt9jmADK__"